export default "__VITE_ASSET__a87dda8b__"